import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormTemplateService } from 'src/app/Services/Forms/form-template.service';
import { Form_Template_With_Fields, Response_Forms } from 'src/app/Interfaces/Forms/FormTemplate.interface';

@Component({
  selector: 'app-form-preview-cdms',
  templateUrl: './form-preview-cdms.component.html',
  styleUrls: ['./form-preview-cdms.component.scss', '../../../Styles/GlobalStyles.css'],
  standalone: false
})
export class FormPreviewCDMSComponent implements OnInit {

  private route = inject(ActivatedRoute);
  private formTemplateService = inject(FormTemplateService);

  public Template: Form_Template_With_Fields | null = null;

  constructor() {}

  ngOnInit(): void {
    const idParam = this.route.snapshot.paramMap.get('id');
    if (idParam) {
      this.formTemplateService.GetFormTemplateById(Number(idParam)).subscribe({
        next: (res: Response_Forms) => {
          if (res.success) {
            this.Template = res.operation;
          }
        }
      });
    }
  }
}
